import { connect } from 'react-redux';
import ButtonModalSK from './ButtonModalSK';
import { modalSKOpen } from '../../../store/actions/modal';

const mapStateToProps = ({ stockReducer }) => ({ stockReducer });
const mapDispatchToProps = { modalSKOpen };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonModalSK);
